export default __webpack_public_path__ + "static/media/ic_fxdx_40.8cd483b1.svg";